import styles from '@/components/app/upgrade/upgrade-view.module.css';
// import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Col, Flex, Row, Space } from 'antd';
// import { useRouter } from 'next/router';
import PlanCard from './components/PlanCard';
import UpgradeBanner from './components/UpgradeBanner';
import UpgradeTable from './components/UpgradeTable';

const UpgradeView = ({ billingCycle, setBillingCycle, plans }) => {
   // const router = useRouter();
   const isYearly = billingCycle === 'yearly';
   return (
      <Flex className={styles.container} vertical align="center" justify="space-between" gap={36}>
         <UpgradeBanner>
            {/* <Button
               style={{ width: 'fit-content', color: '#8E8E9E', padding: '10px 16px', backgroundColor: 'transparent' }}
               icon={<ArrowLeftOutlined />}
               onClick={() => router.back()}
            >
               Back
            </Button> */}
         </UpgradeBanner>
         {/* toggle button view */}
         <ToggleButtons isYearly={isYearly} setBillingCycle={setBillingCycle} />
         {/* cards and table section */}
         <Row gutter={[40, 40]} style={{ width: '100%' }}>
            <Col xs={24} sm={24} md={24} lg={16}>
               <UpgradeTable plans={plans} billingCycle={billingCycle} />
            </Col>

            <Col xs={24} sm={24} md={24} lg={8}>
               <CardsList billingCycle={billingCycle} plans={plans} />
            </Col>
         </Row>
      </Flex>
   );
};

export default UpgradeView;

function ToggleButtons({ isYearly, setBillingCycle }) {
   return (
      <Space size={16} style={{ backgroundColor: '#ECECEC', padding: '8px', borderRadius: '8px' }}>
         <Button type={!isYearly ? 'primary' : 'text'} onClick={() => setBillingCycle('monthly')}>
            Monthly
         </Button>
         <Button
            type={isYearly ? 'primary' : 'text'}
            style={{ padding: '8px' }}
            onClick={() => setBillingCycle('yearly')}
         >
            <Flex justify="space-between" gap={8} align="center" style={{ width: '100%' }}>
               <span>Annually</span>{' '}
               <span
                  style={{
                     color: '#3366FF',
                     fontWeight: '700',
                     fontSize: '12px',
                     padding: '2px 4px',
                     backgroundColor: '#F5F5F8',
                     border: '0 solid',
                     borderRadius: '2px',
                  }}
               >
                  save 20%
               </span>
            </Flex>
         </Button>
      </Space>
   );
}

function CardsList({ billingCycle, plans }) {
   const plansData = plans
      ?.sort((a, b) => a.price - b.price)
      .filter((plan) => plan.showInPricing && plan.billingType === billingCycle && plan);

   const isYearly = billingCycle === 'yearly';
   return (
      <Flex key={billingCycle} vertical style={{ height: '100%' }} gap={32}>
         {plansData?.map((plan) => (
            <PlanCard plan={plan} isYearly={isYearly} key={plan?.title} plans={plans} />
         ))}
      </Flex>
   );
}
